import React from 'react'

import TrainingProfilePlanLengthPageView from './training-profile-plan-length-view'

export default function TrainingProfilePlanLengthPageContainer() {
    return <TrainingProfilePlanLengthPageView />
}
